module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_is-object.js
// module id = /2t/
// module chunks = 1